import * as ApiWithToken from "../callApiWithToken";

const reportsService = {
    getReportListEndPoint: async function (languageID: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_SURVEY_API + `Reports/GetReportList?idLanguage=${languageID}`);
    },

    // ── NEW: returns column metadata instantly (no data fetched) ──────────────
    getReportColumnsEndPoint: async function (sp: string, languageID: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_SURVEY_API + `Reports/GetReportColumns?sp=${sp}&idLanguage=${languageID}`);
    },

    // ── selectedColumns: only those property names are written to the Excel ──
    getReportEndPoint: async function (sp: string, startDate: string, endDate: string, languageID: number, selectedColumns: string[] = []) {
        const colsParam = selectedColumns.length > 0 ? `&selectedColumns=${selectedColumns.join(",")}` : "";
        return ApiWithToken.getApiBlob(process.env.REACT_APP_SURVEY_API + `Reports/${sp}?idLanguage=${languageID}&startDate=${startDate}&endDate=${endDate}${colsParam}`);
    },
    getReportPreviewEndPoint: async function (
        sp: string,
        languageID: number,
        startDate?: string,
        endDate?: string,
        monthDate?: string,
        selectedColumns: string[] = []
    ) {
        const colsParam = selectedColumns.length > 0 ? `&selectedColumns=${encodeURIComponent(selectedColumns.join(","))}` : "";
        const startParam = startDate ? `&startDate=${encodeURIComponent(startDate)}` : "";
        const endParam = endDate ? `&endDate=${encodeURIComponent(endDate)}` : "";
        const monthParam = monthDate ? `&monthDate=${encodeURIComponent(monthDate)}` : "";
        return ApiWithToken.getApi(
            process.env.REACT_APP_SURVEY_API +
            `Reports/GetReportPreview?sp=${encodeURIComponent(sp)}&idLanguage=${languageID}${startParam}${endParam}${monthParam}${colsParam}`
        );
    },
    getReportWeeklyEndPoint: async function (sp: string, weekDate: string, languageID: number, selectedColumns: string[] = []) {
        const colsParam = selectedColumns.length > 0 ? `&selectedColumns=${selectedColumns.join(",")}` : "";
        return ApiWithToken.getApiBlob(process.env.REACT_APP_SURVEY_API + `Reports/${sp}?idLanguage=${languageID}&weekDate=${weekDate}${colsParam}`);
    },
    getReportMonthlyEndPoint: async function (sp: string, monthDate: string, languageID: number, selectedColumns: string[] = []) {
        const colsParam = selectedColumns.length > 0 ? `&selectedColumns=${selectedColumns.join(",")}` : "";
        return ApiWithToken.getApiBlob(process.env.REACT_APP_SURVEY_API + `Reports/${sp}?idLanguage=${languageID}&monthDate=${monthDate}${colsParam}`);
    },

    // ── User Preferences API ──────────────────────────────────────────────────
    getUserPreference: async function (preferenceType: string, pageKey: string) {
        return ApiWithToken.getApi(
            process.env.REACT_APP_SURVEY_API + 
            `Reports/GetUserPreference?preferenceType=${encodeURIComponent(preferenceType)}&pageKey=${encodeURIComponent(pageKey)}`
        );
    },

    saveUserPreference: async function (preferenceType: string, pageKey: string, preferenceValue: string) {
        return ApiWithToken.postApi(
            process.env.REACT_APP_SURVEY_API + `Reports/SaveUserPreference`,
            { preferenceType, pageKey, preferenceValue }
        );
    }
}
export default reportsService;
